import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { loginSuccess } from "store/actions/authActions";
import { Person } from "models/stateTypes/authState";
import SessionHelper from "./sessionHelper";

/**
 * Hook replacement for the deprecated `AuthHelper.authenticate()`. Reads `isAuthorized` via
 * `useSelector` and restores a persisted session through `useDispatch` instead of touching the
 * store singleton directly (see the migration guide on `AuthHelper.authenticate`).
 */
const useAuthHelper = () => {
  const isAuthorized = useSelector((state: AppState) => state.auth.isAuthorized);
  const dispatch = useDispatch();

  const authenticate = (): boolean => {
    if (isAuthorized) return true;

    const userSession = SessionHelper.getSessionItem<Person>("user_session");
    if (userSession && userSession.key) {
      dispatch(loginSuccess(userSession, true));
      return true;
    }

    return false;
  };

  return { authenticate };
};

export default useAuthHelper;
